<template>
    <EditModelLayout
        :indexRoute="$route('admin::companies.index')"
        :updateRoute="$route('admin::companies.update', { company: company.id })"
        :modelNameSingular="__('admin::companies.company')"
        :modelNamePlural="__('admin::companies.companies')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
            company: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.company.name,
                })
            }
        },
    }
</script>
